import { Button } from "@newsela/angelou";
import {
  actionNames,
  actionPrefixes,
  objectTypes,
  withTrackEvent,
} from "@newsela/snitch";
import { useExportablesContext } from "@/components/AIComponents/ExportablesModal/ExportablesContextProvider/useExportablesContext";

import { buttonContainerStyles } from "./ExportablesModalFooter.styles";

const ButtonWithTrackEvent = withTrackEvent(Button);

const StudentActions = () => {
  const { selectedExportable, templateList, handleTemplateSelection } =
    useExportablesContext();

  const currentTemplateIndex =
    templateList?.findIndex(
      ({ seti_identifier }) =>
        seti_identifier === selectedExportable.seti_identifier,
    ) || 0;
  const isFirstTemplate = currentTemplateIndex === 0;
  const isLastTemplate = currentTemplateIndex === templateList.length - 1;

  const getButtonHandler = (direction: "next" | "previous") => {
    return () => {
      handleTemplateSelection(
        templateList[
          direction === "next"
            ? Math.min(currentTemplateIndex + 1, templateList.length - 1)
            : Math.max(currentTemplateIndex - 1, 0)
        ],
      );
    };
  };

  const handleNextButton = getButtonHandler("next");
  const handlePreviousButton = getButtonHandler("previous");

  return (
    <>
      {!isFirstTemplate && (
        <ButtonWithTrackEvent
          flavor={Button.flavors.secondary}
          onClick={handlePreviousButton}
          dataProps={{ "data-qa-selector": "show-previous-graphic-organizer" }}
          objectType={objectTypes.generatedTextAsset}
          actionPrefix={actionPrefixes.initiate}
          actionName={actionNames.navigate}
          streamProperties={{
            description: "Save and show previous Graphic Organizer",
          }}
        >
          Save and previous
        </ButtonWithTrackEvent>
      )}
      <ButtonWithTrackEvent
        onClick={handleNextButton}
        __cssFor={buttonContainerStyles}
        dataProps={{
          "data-qa-selector": isLastTemplate
            ? "save-graphic-organizer-submission"
            : "show-next-graphic-organizer",
        }}
        objectType={objectTypes.generatedTextAsset}
        actionPrefix={actionPrefixes.initiate}
        actionName={isLastTemplate ? actionNames.save : actionNames.navigate}
        streamProperties={{
          description: isLastTemplate
            ? "Save Graphic Organizer submission"
            : "Save and show next Graphic Organizer",
        }}
      >
        {isLastTemplate ? "Save and submit" : "Save and next"}
      </ButtonWithTrackEvent>
    </>
  );
};

export default StudentActions;
